
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M23.333 21.667c-2.756 0-5-2.244-5-5 0-2.757 2.244-5 5-5h3.333V5c0-2.756-2.243-5-5-5H3.75a1.664 1.664 0 00-1.557 2.26l12.084 31.667A1.663 1.663 0 0015.833 35h5.833c2.757 0 5-2.243 5-5v-8.333h-3.333z","fill":"#1B342C"}}),_c('path',{attrs:{"d":"M31.028 24.874A1.67 1.67 0 0130 23.334v-5h-6.667a1.667 1.667 0 010-3.333H30v-5a1.666 1.666 0 012.845-1.178l6.666 6.666a1.665 1.665 0 010 2.356l-6.667 6.667a1.667 1.667 0 01-1.816.362z","fill":"#74DBB5"}}),_c('path',{attrs:{"d":"M14.41 3.504L4.395.166C2.135-.53 0 1.139 0 3.334v30a3.35 3.35 0 002.257 3.163l10.013 3.338c.368.113.707.165 1.063.165a3.336 3.336 0 003.333-3.333v-30a3.351 3.351 0 00-2.256-3.163z","fill":"#1BB58B"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h40v40H0z"}})])])])
          )
        }
      }
    